
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconDomainRowChevron = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 9,
  height: 14,
  viewBox: "0 0 9 14",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.024 11.618c.442.419.406 1.068-.08 1.449a1.337 1.337 0 0 1-1.575.02l-.107-.09L.31 7.358c-.379-.359-.41-.89-.095-1.278l.095-.102L6.262.336c.442-.42 1.195-.45 1.682-.07.449.352.514.932.173 1.349l-.093.1-5.225 4.95 5.225 4.953Z",
  fill: "#fff"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"9\" height=\"14\" viewBox=\"0 0 9 14\" fill=\"none\">\r\n  <path d=\"M8.02389 11.6178C8.46616 12.0369 8.43031 12.6856 7.94381 13.0666C7.49474 13.4183 6.81866 13.4191 6.36945 13.0874L6.26213 12.9976L0.309759 7.35659C-0.0686353 6.99799 -0.100169 6.46609 0.215159 6.0786L0.309759 5.97675L6.26213 0.335727C6.7044 -0.0834086 7.45732 -0.114297 7.94381 0.266735C8.39289 0.618457 8.45798 1.19822 8.11748 1.615L8.02389 1.71557L2.79897 6.66564L8.02389 11.6178Z\" fill=\"white\"/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/icon-domain-row-chevron.6fcd99dce383e493f29f50c786435427.svg"),
        {
          React: SvgIconDomainRowChevron,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      